import { setJrdpSearchParams } from './utils';

export const PREMIUM_TYPE = {
  Standard: 0,
  Premium: 1,
  Deluxe: 2,
} as const;

export const PAGE_CODE = {
  DAI: 'TIKU_DAI_SITE',
  CHU: 'TIKU_CHU_SITE',
  SHOU: 'TIKU_SHOU_SITE',
  SAI: 'TIKU_SAI_SITE',
  ONSEN: 'ONSEN_SITE',
} as const;

export const AREA_LEVEL = {
  LARGE: 'LARGE',
  MIDDLE: 'MIDDLE',
  SMALL: 'SMALL',
  DETAIL: 'DETAIL',
} as const;

export const PAGE_URL = {
  TRAVEL_TOP: 'https://travel.rakuten.co.jp/',
  PROVIDER_TOP: (providerId: string, isDynamicUrl: boolean = false) =>
    isDynamicUrl
      ? `https://hotel.travel.rakuten.co.jp/hinfo/${providerId}/`
      : `https://travel.rakuten.co.jp/HOTEL/${providerId}/${providerId}.html`,
  YADO_NEWS: (providerId: string) => `https://travel.rakuten.co.jp/HOTEL/${providerId}/TOPIC/`,
  PLAN_LIST: (providerId: string) =>
    `https://hotel.travel.rakuten.co.jp/hotelinfo/plan/${providerId}`,
  PLAN_LIST_JRDP: (providerId: string) =>
    `https://travel.rakuten.co.jp/package/jr/hotel_info_plan/${providerId}`,
  ROOM_LIST: (providerId: string) =>
    `https://hotel.travel.rakuten.co.jp/hotelinfo/plan/${providerId}`,
  GALLERY: (providerId: string, isDynamicUrl: boolean = false) =>
    isDynamicUrl
      ? `https://hotel.travel.rakuten.co.jp/hinfo/${providerId}/photo/`
      : `https://travel.rakuten.co.jp/HOTEL/${providerId}/gallery.html`,
  MAP: (providerId: string, isDynamicUrl: boolean = false) =>
    isDynamicUrl
      ? `https://hotel.travel.rakuten.co.jp/hinfo/104620/rtmap/`
      : `https://travel.rakuten.co.jp/HOTEL/${providerId}/rtmap.html`,
  REVIEW: (providerId: string) => `https://travel.rakuten.co.jp/HOTEL/${providerId}/review.html`,
  COUPON: (providerId: string) => `https://coupon.travel.rakuten.co.jp/coupon/hotel/${providerId}`,
  FAVORITE_LIST_DOMESTIC: 'https://favoritelist.travel.rakuten.co.jp/hotel/domestic/',
} as const;

export const MENU_PAGE_CODE = {
  PROVIDER_TOP: 'FACILITY',
  YADO_NEWS: '宿ニュース',
  PLAN_LIST: 'PLAN',
  ROOM_LIST: 'ROOM',
  GALLERY: 'GALLERY',
  MAP: 'S_MAP',
  REVIEW: 'REVIEW',
  COUPON: 'COUPON',
} as const;

export const TAB_URL = (
  providerId: string,
  rtCondSearchParams: URLSearchParams,
  isJRDP: boolean,
  jrdpQuery: string,
) => {
  rtCondSearchParams.set('f_flg', 'PLAN');
  const planFlagSearchParams = rtCondSearchParams.toString();
  rtCondSearchParams.set('f_flg', 'ROOM');
  const roomFlagSearchParams = rtCondSearchParams.toString();

  const jrdpSearchParams = setJrdpSearchParams(isJRDP, jrdpQuery);

  return {
    PROVIDER_TOP: isJRDP
      ? new URL(`${PAGE_URL.PROVIDER_TOP(providerId, true)}?${jrdpSearchParams}`)
      : new URL(`${PAGE_URL.PROVIDER_TOP(providerId)}`),
    YADO_NEWS: new URL(
      `${PAGE_URL.YADO_NEWS(providerId) + (isJRDP ? `?${jrdpSearchParams}` : '')}`,
    ),
    PLAN_LIST: isJRDP
      ? new URL(`${PAGE_URL.PLAN_LIST_JRDP(providerId)}?${jrdpQuery}`)
      : new URL(`${PAGE_URL.PLAN_LIST(providerId)}?${planFlagSearchParams}`),
    ROOM_LIST: new URL(`${PAGE_URL.ROOM_LIST(providerId)}?${roomFlagSearchParams}`),
    GALLERY: isJRDP
      ? new URL(`${PAGE_URL.GALLERY(providerId, true)}?${jrdpSearchParams}`)
      : new URL(`${PAGE_URL.GALLERY(providerId)}`),
    MAP: isJRDP
      ? new URL(`${PAGE_URL.MAP(providerId, true)}?${jrdpSearchParams}`)
      : new URL(`${PAGE_URL.MAP(providerId)}`),
    REVIEW: new URL(PAGE_URL.REVIEW(providerId) + (isJRDP ? `?${jrdpSearchParams}` : '')),
    COUPON: new URL(PAGE_URL.COUPON(providerId) + (isJRDP ? `?${jrdpSearchParams}` : '')),
  } as const;
};
